import React from 'react';
import UnitPageShell from '../../components/shared/UnitPageShell';
import EditableTextBlock from '../../components/shared/EditableTextBlock';
import { Box, Button, IconButton } from '@mui/material';
import { VolumeUp as SpeakerIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTTS } from '../../hooks/useTTS';
import { updateUnitContent, useUnitOverride } from '../../services/unitOverridesService';

const PAGE_ID = 'm1_u1_x7_druckregelung';

const M1_U1_X7_Druckregelung: React.FC = () => {
  const navigate = useNavigate();
  const { token, canEditTextsM1 } = useAuth();
  const { override, refresh } = useUnitOverride(PAGE_ID);

  const textBlocks = React.useMemo(() => ([
    { id: 'block_konstantdruck', heading: 'Konstantdruck-Regelung Zuluft und Abluft', text: override?.texts?.['block_konstantdruck'] ?? 'Drucksensoren in Zu- und Abluftkanal regeln über Frequenzumformer die Lüfterdrehzahl. Gesamtluftmenge passt sich geöffneten Volumenstromreglern an.' },
    { id: 'block_regler_einstellungen', heading: 'Regler-Einstellungen', text: override?.texts?.['block_regler_einstellungen'] ?? 'Sollwert Zuluft-Druck: ca. 120 Pa | Sollwert Abluft-Druck: ca. 80 Pa' },
    { id: 'block_steuerpotentiometer', heading: 'Steuerpotentiometer Frequenzumformer', text: override?.texts?.['block_steuerpotentiometer'] ?? '0–100%: Handbetrieb feste Leistung. Auto: DDC übernimmt Drehzahlregelung.' },
    { id: 'block_stoerungen', heading: 'Störung Frequenzumformer', text: override?.texts?.['block_stoerungen'] ?? 'Interne elektronische Überwachung; Reset am Gerät oder über DDC nach Behebung.' }
  ]), [override]);

  const fullPlainText = React.useMemo(() => {
    return textBlocks.map(b => `${b.heading}. ${b.text}`).join(' ');
  }, [textBlocks]);

  const { speak, stop, speaking } = useTTS({ text: fullPlainText });

  const handleTextSave = React.useCallback(async (blockId: string, newBody: string) => {
    if (!token) return alert('Kein Token – bitte einloggen.');
    if (!canEditTextsM1) return alert('Keine Berechtigung zum Texte bearbeiten.');
    try {
      await updateUnitContent(PAGE_ID, { texts: { [blockId]: newBody } }, token);
      alert('Text gespeichert.');
      refresh();
    } catch (e: any) {
      alert('Speichern fehlgeschlagen: ' + (e?.message || e));
    }
  }, [token, refresh, canEditTextsM1]);

  const ttsButton = React.createElement(IconButton, {
    onClick: speaking ? stop : speak,
    'aria-label': 'Text vorlesen',
    sx: { ml: 1 }
  }, React.createElement(SpeakerIcon, { sx: { fontSize: 28 } }));

  return React.createElement(
    UnitPageShell,
    { title: '1.1.7 Druckregelung', actions: ttsButton },
    React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2, maxWidth: '800px' } },
      textBlocks.map((block) => React.createElement(EditableTextBlock, {
        key: block.id,
        pageId: PAGE_ID,
        blockId: block.id,
        heading: block.heading,
        body: block.text,
        onSave: (newBody: string) => handleTextSave(block.id, newBody)
      })),
      React.createElement(Box, { sx: { mt: 3 } },
        React.createElement(Button, { variant: 'outlined', onClick: () => navigate('/units/m1_u1_x99_quiz') }, 'Zum Quiz')
      )
    )
  );
};

export default M1_U1_X7_Druckregelung;
